// extracted by mini-css-extract-plugin
export default {"Accordion":"Accordion__Accordion___eEwu3","title":"Accordion__title___zjLWg","content":"Accordion__content___UfPEf"};